import { mainFee } from "api/endpoints";
import { importView } from "../utils/misc";

const FeeList = importView("Fee/List");

const feeRoutes = {
  path: "/",
  children: [
    {
      path: mainFee.main,
      element: <FeeList />,
    },
  ],
};

export default feeRoutes;
